import { render, staticRenderFns } from "./_workFloGeneralInternalManagement.vue?vue&type=template&id=2aa0b989&scoped=true&"
import script from "./_workFloGeneralInternalManagement.vue?vue&type=script&lang=js&"
export * from "./_workFloGeneralInternalManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa0b989",
  null
  
)

export default component.exports